import { AxiosResponse, AxiosError } from "axios";
import { useMutation } from "react-query";

import useAxios from "@src/config/axios/useAxios";
import { getEditSingleCustomTestUrl } from "@src/config/baseUrls";

export type EditCustomResultsModel = EditCustomResultsFormValue[];

interface EditCustomResultsFormValue {
  label: string;
  value?: string;
  isPassed: boolean;
}

const useEditCustomTestResults = (studyId: string, testId: string) => {
  const axios = useAxios();

  return useMutation<AxiosResponse<string>, AxiosError, EditCustomResultsModel>(
    ["editResults", studyId, testId],
    (values) => axios.put(getEditSingleCustomTestUrl(studyId, testId), values),
  );
};

export default useEditCustomTestResults;
